// Vertical scroll-controlled slider for cooperation stages with GSAP ScrollTrigger pinning
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {
    var $section = $('.s1');
    var $sliderWrapper = $('.js-cooperation-slider');

    if (!$section.length || !$sliderWrapper.length || typeof window.Swiper === 'undefined') {
        return;
    }

    var swiper = new Swiper('.cooperationSwiper', {
        direction: 'horizontal', // kierunek nie ma znaczenia przy fade
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: true,
        speed: 600,
        pagination: {
            el: '.cooperationSwiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.cooperationSwiper-button-next',
            prevEl: '.cooperationSwiper-button-prev',
        },
    });

    // ScrollTrigger: pin sekcji i mapowanie scrolla na slajdy Swipera
    ScrollTrigger.create({
        trigger: $section[0],
        start: 'top top+=150', // niewielki margines od góry
        end: function () {
            return '+=' + ($section.outerHeight() * swiper.slides.length);
        },
        pin: true,
        scrub: true,
        anticipatePin: 1,
        onUpdate: function (self) {
            if (!swiper || !swiper.slides.length) return;
            var progress = self.progress; // 0..1
            var maxIndex = swiper.slides.length - 1;
            var targetIndex = Math.round(progress * maxIndex);
            if (targetIndex !== swiper.activeIndex) {
                swiper.slideTo(targetIndex);
            }
        },
    });
});
